<template>
  <div class="user-center-favoritec">
    <Dialog ref="dialog" :config="config"> </Dialog>
    <div>
      <div class="ohead">
        <el-input
          class="uiInput searchInput"
          v-model="form.keywords"
          :placeholder="$fanyi('请输入关键词搜索')"
          prefix-icon="el-icon-search"
          clearable
          @keyup.enter.native="getShopsList"
        />
        <el-button class="uiBtn uiGreen searchBtn" @click="getShopsList">{{
          $fanyi("搜索")
        }}</el-button>
      </div>
      <div class="tallys">
        <span
          :class="item.titleChecked ? 'active' : ''"
          @click="tabBtnClick(item)"
          v-for="(item, index) in tagLists"
          :key="index"
          >{{ item.tag_name }}</span
        >
      </div>
      <div class="shops" v-if="shopData.length != 0" v-loading="loading">
        <div
          class="shopsOpt"
          v-for="(shopDataitem, shopDataindex) in shopData"
          :key="shopDataindex"
        >
          <div class="optLeft flex fdcolmun">
            <div
              class="goodsTitleBox"
              @click="
                $fun.routerToPage(
                  '/shopGoods?shopName=' +
                    shopDataitem.shop_name +
                    '&shopId=' +
                    shopDataitem.shop_id,
                )
              "
              :title="shopDataitem.shop_name"
            >
              <div class="rowTitle">{{ $fanyi("店铺名称") }}</div>

              <div class="shopName">
                {{ shopDataitem.shop_name }}
              </div>
            </div>
            <div class="remarkRow">
              <div class="rowTitle">{{ $fanyi("备注栏") }}</div>
              <div class="flex acenter">
                <el-input
                  class="uiInput shopNoteInput"
                  v-model="shopDataitem.note"
                  :placeholder="$fanyi('备注')"
                  @change="changeNote(shopDataitem.id, shopDataitem.note)"
                />
                <div class="shopCardIconGroup">
                  <el-popover
                    placement="right"
                    trigger="click"
                    popper-class="favoritec-shop-tag-popper"
                  >
                    <div
                      @click.stop
                      class="pop-up"
                      v-if="shopDataitem.showTagWin"
                    >
                      <div class="tag-list">
                        <div
                          class="tag-item"
                          v-for="(otem, ondex) in tagLists"
                          :key="otem.tag_id || ondex"
                        >
                          <label class="tag-checkbox">
                            <input
                              type="checkbox"
                              v-model="otem.checked"
                              @change="
                                checkTagAdd(shopDataitem.id, shopDataitem)
                              "
                            />
                            <span class="tag-name" :title="otem.tag_name">{{
                              otem.tag_name
                            }}</span>
                          </label>
                          <img
                            class="del-icon"
                            @click.stop="delTag(otem.tag_id, ondex)"
                            src="../../../../assets/newImg/shanchu.svg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div class="addTagBtn">
                        <el-input
                          class="uiInput"
                          size="small"
                          v-model="addTagTxt"
                          @keyup.enter.native="addTag(shopDataitem)"
                        />
                        <el-button
                          class="uiBtn uiGreen"
                          @click="addTag(shopDataitem)"
                        >
                          {{ $fanyi("添加") }}
                        </el-button>
                      </div>
                    </div>
                    <img
                      slot="reference"
                      class="tagIcon"
                      @click.stop="shopTagOpen(shopDataitem)"
                      src="../../../../assets/user-img/biaoQian.svg"
                      alt=""
                    />
                  </el-popover>
                  <img
                    class="delIcon"
                    src="../../../../assets/user-img/lajiTung.svg"
                    alt=""
                    @click="delshop(shopDataindex, shopDataitem)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="optRight">
            <div
              class="carouselBtn carouselBtn--prev"
              @click="shopCarouselChange('left', shopDataindex)"
            >
              <img :src="require('@/assets/icon/jiantou.svg')" alt="" />
            </div>

            <el-carousel
              ref="shopCarousel"
              trigger="click"
              width="100px"
              height="100px"
              :autoplay="false"
              arrow="never"
              indicator-position="none"
            >
              <el-carousel-item
                v-for="(goodsItem, goodsIndex) in shopDataitem.goods"
                :key="goodsIndex"
              >
                <div class="optRightCon">
                  <div
                    class="shopGoods"
                    v-for="(iu, sndex) in (goodsItem || []).filter(Boolean)"
                    :key="sndex"
                    @click="$fun.toCommodityDetails(iu.goods_id, iu)"
                  >
                    <el-image :src="(iu && iu.imgUrl) || ''">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                      <div slot="placeholder">
                        <i class="el-icon-loading"></i>
                      </div>
                    </el-image>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div
              class="carouselBtn"
              @click="shopCarouselChange('right', shopDataindex)"
            >
              <img :src="require('@/assets/icon/jiantou.svg')" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="tishi">
        {{ $fanyi(pageMsg) }}
      </div>
      <div class="allpag">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.page"
          :page-size="form.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Dialog from "../../../../components/public/Dialog.vue";

export default {
  data() {
    return {
      pageMsg: "暂无数据",
      tagLists: [], //标签列表
      shopData: [], //收藏店铺列表
      addTagTxt: "", //添加标签的文本
      loading: true,
      total: 0,
      form: {},
      config: {
        top: "20vh",
        width: "500px",
        title: this.$fanyi("提示"),
        btnTxt: [this.$fanyi("删除"), this.$fanyi("取消")],
      }, // 弹框属性
    };
  },
  components: {
    Dialog,
  },
  computed: {},
  created() {
    this.getTagData();
    this.form.pageSize = 5;
    this.getShopsList("one");
  },
  mounted() {
    document.addEventListener("click", this.bodyCloseMenus);
  },
  methods: {
    // ***********************标签事件******************************************************
    // 添加标签
    addTag(item) {
      if (!this.addTagTxt) return false;
      this.$api
        .favoriteTagAdd({
          type: 2,
          tag_name: this.addTagTxt,
        })
        .then((res) => {
          //console.log("favoriteTagDelete", res);
          if (res.code != 0) return;
          this.addTagTxt = "";
          // 重新获取标签列表
          this.$api.favoriteTagList({ type: "2" }).then((res) => {
            //console.log("favoriteTagList", res);
            this.tagLists = res.data;
            // 调用处理标签列表事件
            this.tagDataProcessing();
            this.shopTagOpen(item);
            this.$forceUpdate();
          });
        });
    },
    // 将店铺分配到选中的标签里去
    checkTagAdd(id, item) {
      let ids = [];
      this.tagLists.forEach((item) => {
        if (item.checked) ids.push(item.tag_id);
      });
      //console.log(this.tagLists);
      ids = ids.join(",");
      let datas = {
        id: id,
      };
      if (ids) {
        datas.tag_ids = ids;
      } else {
        datas.tag_ids = "";
      }
      this.$api.favoriteShopToTags(datas).then((res) => {
        //console.log("favoriteShopToTags", res);
        if (res.code != 0) return;
        item.tag_ids = ids;
      });
    },
    // 删除标签
    delTag(id, index) {
      this.$api
        .favoriteTagDelete({
          tag_id: id,
        })
        .then((res) => {
          //console.log("favoriteTagDelete", res);
          if (res.code != 0) return;
          this.tagLists.splice(index, 1);
        });
    },
    // 全局鼠标点击事件
    bodyCloseMenus() {
      // 关闭所有商品的标签弹窗
      this.shopData.forEach((item) => {
        item.showTagWin = false;
      });
      this.$forceUpdate();
    },
    // 标签按钮点击事件
    tabBtnClick(item) {
      // 设置选中便签的值
      item.titleChecked = !item.titleChecked;
      this.$forceUpdate();
      this.getShopsList("tagShops");
    },
    // 获取商品收藏夹标签列表并调用商品收藏夹列表获取函数
    getTagData() {
      this.$api.favoriteTagList({ type: "2" }).then((res) => {
        //console.log("favoriteTagList", res);
        this.tagLists = res.data;
        // 调用处理标签列表事件
        this.tagDataProcessing();
        // 调用获取商品收藏夹列表事件
      });
    },
    // 处理收藏夹标签数据
    tagDataProcessing() {
      this.tagLists.forEach((item) => {
        item.checked = false;
        item.titleChecked = false;
      });
    },
    // ******************商店事件*************************************************
    // 修改店铺备注
    changeNote(id, note) {
      this.$api
        .favoriteShopNoteSave({
          id: id,
          note: note,
        })
        .then((res) => {
          //console.log("favoriteShopNoteSave", res);
          if (res.code != 0) return;
        });
    },
    // 分页事件
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.form.page_num = val;
      this.form.page = 1;
      this.getShopsList("one");
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.form.page = val;
      this.getShopsList("one");
    },
    // 滑动店铺商品列表
    shopCarouselChange(type, index) {
      if (type == "left") {
        this.$refs.shopCarousel[index].prev();
      } else if (type == "right") {
        this.$refs.shopCarousel[index].next();
      }
    },
    // 获取店铺列表
    getShopsList(type) {
      this.loading = true;
      let datas = {
        tag_ids: "",
        page: this.form.page,
        pageSize: this.form.pageSize,
        keywords: this.form.keywords,
      };

      let tagIds = [];
      this.tagLists.forEach((item) => {
        if (item.titleChecked) tagIds.push(item.tag_id);
      });
      tagIds = tagIds.join(",");
      datas.tag_ids = tagIds;
      this.$api
        .favoriteShopList(datas)
        .then((res) => {
          this.loading = false;
          //console.log("favoriteShopList", res);
          this.shopData = res.data.data;
          this.total = res.data.total;
          this.ProcessingShopData();
        })
        .catch((err) => {});
      this.ProcessingShopData();
    },
    //处理店铺数据
    ProcessingShopData() {
      //console.log("sdafsadf");
      //console.log(this.shopData);

      this.shopData.forEach((item) => {
        if (!Array.isArray(item.goods)) {
          item.goods = [];
        }
        // 去掉接口里的空项，避免 v-for 里 iu 为 undefined
        item.goods = item.goods.filter((g) => g != null);
        if (item.goods.length === 0) {
          item.showTagWin = false;
          return;
        }
        let lack = 4 - (item.goods.length % 4); //取得店铺商品数离4个的倍数差多少个商品的数量
        //console.log("缺多少个商品", lack);
        //差多少个就从最前面取多少个填充到最后
        for (let i = 0; i < lack; i++) {
          item.goods.push(item.goods[i]);
        }
        //  把单个店铺的商品分成四个一组
        item.goods = this.$fun.changeArr(item.goods, 4);
        item.showTagWin = false;
      });
      //console.log(this.shopData);
      this.$forceUpdate();
    },

    // 打开分配店铺标签窗口
    shopTagOpen(item) {
      this.shopData.forEach((s) => {
        s.showTagWin = false;
      });
      const raw = item.tag_ids;
      const shopsTagIds =
        raw == null || raw === ""
          ? []
          : String(raw)
              .split(",")
              .filter((id) => id !== "");

      this.tagLists.forEach((tag) => {
        if (shopsTagIds.indexOf(String(tag.tag_id)) !== -1) {
          tag.checked = true;
        } else {
          tag.checked = false;
        }
      });

      item.showTagWin = true;
      this.$forceUpdate();
    },
    // 删除店铺
    delshop(index, item) {
      this.$refs.dialog.open(
        this.$fanyi("是否删除此店铺"),
        () => {
          this.$api.favoriteShopDelete({ id: item.id }).then((res) => {
            //console.log("favoriteGoodsDelete", res);
            if (res.code != 0) {
              return;
            }

            this.getShopsList();
          });
        },
        () => {},
      );
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

.user-center-favoritec {
  width: 100%;

  > div {
    background: #ffffff;
    border: 1px solid #e1e1e1;
    padding: 20px;
    border-radius: 12px;

    .ohead {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .searchInput {
        min-width: 0;
        margin-right: 12px;
        width: 360px;

        /deep/ .el-input__inner {
          height: 40px;
          font-size: 14px;
          border-radius: 8px;
          border: 0.5px solid #d0d5dd;
          transition: border-color 0.3s;
          &::placeholder {
            color: #d0d5dd;
          }
          &:focus {
            border-color: #009246;
          }
        }

        /deep/ .el-input__prefix .el-input__icon {
          font-size: 15px;
          color: #000000;
        }
      }

      .searchBtn {
        height: 40px;
      }
    }
    .tallys {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 20px;
      gap: 8px;
      span {
        cursor: pointer;
        @extend .dip;
        height: 28px;
        border-radius: 8px;
        border: 1px solid #eaecf0;
        padding: 0px 8px;
        font-size: 14px;
        line-height: 20px;
        &.active {
          border: 1px solid #009246;
          color: #009246;
        }
      }
    }
    .shops {
      width: 100%;
      min-height: 300px;
      .shopsOpt {
        width: 100%;
        height: unset;
        border-radius: 24px;
        border: 1px solid rgba(0, 146, 70, 0.3);
        padding: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .optLeft {
          width: 396px;
          height: 100%;
          position: relative;
          .rowTitle {
            font-size: 14px;
            font-weight: bold;
            line-height: 20px;
            margin-bottom: 8px;
          }
          .goodsTitleBox {
            cursor: pointer;
            margin-bottom: 16px;

            .shopName {
              font-size: 16px;
              font-weight: normal;
              line-height: 20px;
              height: 40px;
              @extend .spanOv2;
            }
          }
          .remarkRow {
          }
          .shopNoteInput {
            width: 300px;
            min-width: 0;
            margin-right: 6px;
            /deep/ .el-input__inner {
              height: 30px;
              line-height: 30px;
              border-radius: 999px;
              border: 1px solid #eaecf0;
              background: #ffffff;
              font-size: 14px;
              transition: border-color 0.3s;
              &:focus {
                border-color: #009246;
              }
            }
          }
          .shopCardIconGroup {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 6px 10px;
            border-radius: 8px;
            .tagIcon,
            .delIcon {
              width: 18px;
              height: 18px;
              cursor: pointer;
              display: block;
            }
          }
        }
        .optRight {
          width: 580px;
          // margin: 20px 30px 0 20px;
          // 轮播图两侧样式
          display: flex;
          justify-content: space-between;
          align-items: center;
          .carouselBtn {
            width: 40px;
            height: 40px;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 20px;
            }
            &.carouselBtn--prev img {
              transform: scaleX(-1);
            }
          }
          /deep/.el-carousel__arrow--right,
          /deep/.el-carousel__arrow--left {
            height: 0;
            overflow: hidden;
          }
          .el-carousel {
            width: 460px;
          }
          /deep/ .el-carousel__arrow {
            background: rgba(255, 255, 255, 0.5);
            i {
              color: $homePageSubjectColor;
            }
          }
          /deep/.el-carousel__button {
            width: 12px;
            height: 12px;
            background: #ffffff;
            border-radius: 50%;
          }
          /deep/.el-carousel__indicator.el-carousel__indicator--horizontal.is-active
            .el-carousel__button {
            background-color: transparent;
          }

          .optRightCon {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .shopGoods {
              width: 100px;
              height: 100px;
              cursor: pointer;
              /deep/.el-image {
                $imgSize: 100px;
                width: $imgSize;
                height: $imgSize;
                transition: 0.3s;
                text-align: center;
                i {
                  font-size: $imgSize/4;
                  line-height: $imgSize;
                }
              }
            }
          }
        }
      }
    }
    .tishi {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 300px;
      font-size: 25px;
      font-weight: bold;
      color: #bcb8b8;
    }
    .allpag {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 25px 0;

      > a {
        display: inline-block;
        border: 1px solid #dfe8df;
        height: 28px;
        background-color: white;
        text-align: center;
        padding: 0 10px;
        font-size: 13px;
        line-height: 28px;
        border-radius: 2px;
      }

      /* 分页被选中的页码样式 */
      /deep/ .el-pager li {
        margin: 0 3px;
        border-radius: 4px;
        box-shadow: 0px 0px 6px 0px rgba(61, 61, 61, 0.1);

        &:hover {
          color: $homePageSubjectColor;
        }

        &.active {
          background-color: $homePageSubjectColor;
          color: white;
        }
      }
    }
  }
}
</style>

<style lang="scss">
/* el-popover 挂到 body，scoped 无法命中 */
.favoritec-shop-tag-popper {
  padding: 12px;
  min-width: 240px;
  .pop-up {
    width: 240px;
  }
  .tag-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
  }
  .tag-item {
    display: flex;
    align-items: center;
    .tag-checkbox {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
      margin: 0;
      cursor: pointer;
      font-weight: normal;
      input[type="checkbox"] {
        flex-shrink: 0;
        width: 14px;
        height: 14px;
        margin: 0;
        cursor: pointer;
      }
      .tag-name {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .del-icon {
      width: 16px;
      height: 16px;
      cursor: pointer;
      flex-shrink: 0;
    }
  }
  .addTagBtn {
    display: flex;
    align-items: center;
    gap: 10px;
    .uiInput {
      flex: 1;
      min-width: 0;
      height: 32px;
    }
    .uiBtn {
      height: 32px;
    }
  }
}
</style>
